import React from "react";
import { Layout } from "element-react";

export default function WizardLeftMenu({step}) {
    return (
        <Layout.Col xs="24" sm="24" md="4" lg="4">
        <div className="create-store-steps">
        <h3>Steps</h3>
        <div className={step === -1 ? "step-active" : "step-done"}>
                <div className="status-check">
                    {
                        step === -1 ? <div className="">1</div> : <div id="checkmark"/>
                    }    
                </div>             
            <p>Getting Started</p>
        </div>
        <div className={step === 0 ? "step-active" : step > 0 ? "step-done" : "step-inactive"}>
                <div className="status-check">
                    {
                        step === 0 ? <div className="">2</div> : step > 0 ? <div id="checkmark"/> : <div className="">3</div>
                    }    
                </div>             
            <p>Company</p>
        </div>
        <div className={step === 1 ? "step-active" : step > 1 ? "step-done" : "step-inactive"}>
                <div className="status-check">
                    {
                        step === 1 ? <div className="">3</div> : step > 1 ? <div id="checkmark"/> : <div className="">3</div>
                    }    
                </div>             
            <p>Capacity</p>
        </div>
        <div className={step === 2 ? "step-active" : step > 2 ? "step-done" : "step-inactive"}>
            <div className="status-check">4</div>
            <p>Pictures</p>
        </div>
        </div>
      </Layout.Col>
    );
}